<template>
  <div>
    <v-btn
      block
      class="secondary rounded-pill my-4"
      @click.stop="dialogForm = true"
      ><v-icon class="mr-4">mdi-tractor-variant</v-icon> Nouvelle Dotation de
      matériel</v-btn
    >
    <v-dialog
      v-model="dialogForm"
      fullscreen
      hide-overlay
      transition="slide-x-transition"
    >
      <v-card>
        <v-app-bar class="transparent" light flat>
          <v-toolbar-title>
            <v-btn icon @click="dialogForm = false">
              <v-icon>mdi-arrow-left</v-icon> </v-btn
            >Nouvelle Dotation de matériel ({{ projet }})
          </v-toolbar-title>
        </v-app-bar>
        <v-card-title>
          {{ groupe.nom_groupe }}
        </v-card-title>
        <v-card-text>
          <v-form ref="form" lazy-validation>
            <v-container fluid>
              <v-row no-gutters="">
                <v-col cols="12">
                  <v-text-field
                    dense
                    v-model="ll_dotation"
                    label="Libellé"
                    prepend-icon="person"
                    :rules="requis"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-menu
                    v-model="menu2"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="computedDateDebutFormattedMomentjs"
                        label="Date de la dotation"
                        prepend-icon="mdi-calendar-cursor"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        :rules="requis"
                        required
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      locale="fr"
                      v-model="date_dotation"
                      no-title
                      @input="menu2 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="12">
                  <v-autocomplete
                    v-model="activite_selected"
                    ref="activite_selected"
                    @change="selectActivite()"
                    dense
                    :items="activites"
                    label="Activités"
                    outlined
                    item-value="ll_parcours"
                    item-text="ll_parcours"
                    :rules="selectRules"
                  ></v-autocomplete>

                  <v-text-field
                    dense
                    v-model="nombreTotal"
                    label="Nombre d'intrants"
                    prepend-icon="mdi-wheel-barrow"
                    type="number"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions class="pb-4">
          <v-btn class="rounded-pill neumorphic warning" @click="reset"
            >Annuler</v-btn
          >
          <v-btn
            class="rounded-pill neumorphic primary"
            :loading="newLoading"
            @click="create"
            >Insérer la Dotation</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  created() {
    //this.setActivite();
  },
  data() {
    return {
      newLoading: false,
      dialogForm: false,
      requis: [
        (v) => !!v || "Ce champ est obligatoire",
        (v) => (v && v.length >= 3) || "Au moins trois caractères",
      ],
      emailRules: [
        (v) => !!v || "E-mailrequis",
        (v) => /.+@.+\..+/.test(v) || "E-mail invalide",
      ],
      selectRules: [(v) => !!v || "Veuillez sélectionner une valeur"],
      bailleur_selected: "",
      projet_selected: "",
      activite_selected: "",
      //activites: [],
      menu2: false,
      date_dotation: "",
      ll_dotation: "",
      nombreTotal: "0",
    };
  },
  props: {
    groupe: {
      type: Object,
      required: true,
    },

    projet: {
      required: true,
    },
    id: {
      required: true,
    },
  },
  methods: {
    create() {
      if (this.$refs.form.validate()) {
        var self = this;
        this.newLoading = true;
        let uuid = this.$uuid.v4();

        var newDotation = {
          date_dotation: this.date_dotation,
          nom_groupe: this.groupe.nom_groupe,
          programmes_id_programme: this.$refs.activite_selected.selectedItems[0]
            .programmes_id_programme,
          responsable: this.groupe.responsable,
          groupes_code_groupe: this.id,
          ll_theme: this.$refs.activite_selected.selectedItems[0].ll_theme,
          abbr_parcours: this.$refs.activite_selected.selectedItems[0]
            .abbr_parcours,
          ll_dotation: this.ll_dotation,
          id_commune: this.groupe.id_commune,
          //id_province: this.groupe.ll_province,
          ll_commune: this.groupe.ll_commune,
          ll_region: this.groupe.ll_region,
          id: uuid,
          id_region: this.groupe.id_region,
          ll_district: this.groupe.ll_district,
          //ll_province: this.groupe.ll_province,
          id_district: this.groupe.id_district,
          ll_fokontany: this.groupe.ll_fokontany,
          parcours_id_parcours: this.$refs.activite_selected.selectedItems[0]
            .id,
          ll_programme: this.$refs.activite_selected.selectedItems[0]
            .ll_programme,
          nom_responsable: this.groupe.nom_responsable,
          themes_id_theme: this.$refs.activite_selected.selectedItems[0]
            .themes_id_theme,
          ll_parcours: this.$refs.activite_selected.selectedItems[0]
            .ll_parcours,
          description_parcours: this.$refs.activite_selected.selectedItems[0]
            .description_parcours,
          bailleurs_id_bailleur: this.$refs.activite_selected.selectedItems[0]
            .bailleurs_id_bailleur,
          id_bailleur: this.$refs.activite_selected.selectedItems[0]
            .bailleurs_id_bailleur,
          ll_bailleur: this.$refs.activite_selected.selectedItems[0]
            .ll_bailleur,
          objectifs: this.$refs.activite_selected.selectedItems[0].objectifs,
          abbr_bailleur: this.$refs.activite_selected.selectedItems[0]
            .abbr_bailleur,
          nombreTotal: this.nombreTotal,
        };
        //Dotation de groupe
        this.$firebase
          .firestore()
          .collection("dotationsDeGroupe")
          .doc(uuid)
          .set(newDotation, { merge: true });
        console.log("Dotation de groupe créée id: " + uuid);
        this.GetDotationsDeGroupe(this.id);
        //vuex insert Dotation
        this.addOneItem(newDotation);
        this.reset();
      } else {
        console.log("veuillez valider d'abord");
      }
    },
    reset() {
      this.$refs.form.reset();
      this.communes = [];
      this.newLoading = false;
      this.dialogForm = false;
    },
    setMyProjects(ParcoursEffectif) {
      let projects = [];
      _.forEach(ParcoursEffectif, function (item, index) {
        projects[index] = item.ll_programme;
      });
      return _.uniq(projects);
    },
    setActivite() {
      let self = this;
      self.activites = [];
      this.$firebase
        .firestore()
        .collection("activites")
        .where("ll_programme", "==", this.projet)
        .get()
        .then((snap) => {
          snap.forEach((doc) => {
            var activite = doc.data();
            activite.id = doc.id;
            self.activites.push({
              ...activite,
            });
          });
        });
    },
    selectActivite() {
      console.log(this.activite_selected);
    },
    ...mapActions({
      GetDotationsDeGroupe: "DotationsDeGroupe/GetDotationsDeGroupe",
      addOneItem: "DotationsDeGroupe/addOneItem",
    }),
  },
  computed: {
    computedDateDebutFormattedMomentjs() {
      return this.date_dotation
        ? this.$moment(this.date_dotation).format("DD-MM-YYYY")
        : "";
    },

    ...mapState({
      bailleurs: (state) => state.Bailleurs.bailleurs,
      ParcoursEffectif: (state) => state.ParcoursEffectif.ParcoursEffectif,
      activites(state) {
        return _.filter(state.Activites.Activites, {
          ll_programme: this.projet,
        });
      },
    }),
  },
};
</script>

<style lang="scss" scoped></style>
